exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-container {\n    width: 350px;\n    height: 350px;\n    float: center;\n    margin-top: 20px;\n}\n\n.img-preview {\n    width: 100px;\n    height: 100px;\n    float: center;\n    margin-left: 10px;\n}", ""]);

// exports
